function Billings() {
    return (
      <>
        <div className="font-bold text-lg mb-16">Billings</div>
      </>
    );
  }
  
  export default Billings;